import React from 'react';
import cx from 'classnames';
import { ReactSVG } from 'react-svg';
import { Title } from '../Title';

var Step = function Step(_ref) {
  var number = _ref.number,
      illustration = _ref.illustration,
      line = _ref.line,
      title = _ref.title,
      stepClass = _ref.stepClass,
      illustrationClass = _ref.illustrationClass,
      full = _ref.full,
      bottom = _ref.bottom,
      reverse = _ref.reverse,
      children = _ref.children;
  var stepClasses = cx('step', stepClass && stepClass, reverse && 'reverse', full && 'full');
  var illustrationClasses = cx('illustration', illustrationClass && illustrationClass);
  var contentClasses = cx('content', full && 'center', bottom && 'bottom');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stepClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: illustrationClasses
  }, /*#__PURE__*/React.createElement(ReactSVG, {
    src: illustration
  })), /*#__PURE__*/React.createElement("div", {
    className: contentClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "num"
  }, number), /*#__PURE__*/React.createElement(Title, {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", null, children)))), !!line && /*#__PURE__*/React.createElement("div", {
    className: "step-line"
  }, /*#__PURE__*/React.createElement(ReactSVG, {
    src: line
  })));
};

Step.displayName = 'Step';
var StepDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  StepDoc = require('./doc').doc(Step);
}

var StepWrapper = StepDoc || Step;
export { StepWrapper as Step };